<template>
  <v-container fluid>
    <v-data-table locale="fr" :headers="headers" @click:row="goto" :search="search"
      no-data-text="Aucun dossier de consultations disponible" :items="this.$store.getters['Auth/getListDoc']"
      sort-by="createdAt" class="elevation-1 mb-5 px-5">
      <template v-slot:[`item.valid`]="{ item }">
        <v-chip label small outlined :color="`${item.valid ? 'green' : 'red'}`">
          {{ formatValid(item.valid) }}
        </v-chip>
      </template>
      <template v-slot:[`item.extensionList`]="{ item }">
        <v-chip label small outlined
          :color="`${item.extensionList && item.extensionList.length > 0 ? 'green' : 'red'}`">
          {{ formatAdditif(item.extensionList) }}
        </v-chip>
      </template>
      
      <template v-slot:[`item.extensionList.valid`]="{ item }">
        <v-chip v-if="hasAdditif(item)" label small outlined
          :color="`${item.extensionList[item.extensionList.length - 1].valid ? 'green' : 'red'}`">
          {{ formatAdditifValid(item.extensionList[item.extensionList.length - 1].valid) }}
        </v-chip>
        <span v-else>---</span>
      </template>
      <template v-slot:top>
        <v-toolbar flat color="white" class="mb-5">
          <v-toolbar-title v-show="$vuetify.breakpoint.mdAndUp">Liste des dossiers envoyés</v-toolbar-title>
          <v-divider class="mx-4" inset vertical v-show="$vuetify.breakpoint.mdAndUp"></v-divider>
          <v-spacer v-show="$vuetify.breakpoint.mdAndUp"></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Recherchez un dossier de consultation"
            single-line hide-details></v-text-field>
        </v-toolbar>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  components: { DatePicker },
  data: () => ({
    search: "",
    NoticeFiltered: [],
    items: [
      {
        text: "Tableau de bord",
        disabled: false,
        href: "/dashboard"
      },
      {
        text: "Mes Documents",
        disabled: true
      }
    ],
    dog: true,
    noticeType: [],
    doc: {
      object: "",
      type: [],
      notice: [],
      file: [],
      file_letter: [],
    },
    dialog: false,
    headers: [
      {
        text: "Objet du dossier",
        sortable: true,
        value: "object"
      },
      { text: "Type de dossier de consultation", value: "documentType.title" },
      { text: "Avis concerné", value: "object", sortable: false },
      {
        text: "Status",
        sortable: false,
        filterable: false,
        value: "valid",
        align: "center",
        formatValid: (value) => (value ? "validé" : "non validé")
      },
      {
        text: "Additif",
        sortable: false,
        filterable: false,
        value: "extensionList",
        align: "center",
        formatAdditif: (value) => (value && value.length > 0 ? "Oui" : "Non")
      },
      {
        text: "Status de l'additif",
        sortable: false,
        filterable: false,
        value: "extensionList.valid",
        align: "center",
        formatAdditifValid: (value) => (value ? "validé" : "non validé")
      }
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      calories: "",
      fat: 0,
      carbs: 0,
      protein: 0
    },
    defaultItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0
    }
  }),
  filters: {
    date(val) {
      return val ? val.toLocaleString() : "";
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Envoi d’un nouvel dossier de consultation"
        : "Création du Plan de Passation des Marchés";
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  created() {
    this.$store.dispatch("Auth/loadAllNotice");
    this.$store.dispatch("Auth/loadAllDoc");
    console.log("LES INFOS", this.$store.getters["Auth/getListDoc"]);
    this.$store.dispatch("Auth/getData");
  },
  methods: {
    ...mapActions({
      addDocForAno: "Auth/addDocForAno",
      loadAllNotice: "Auth/loadAllNotice"
    }),

    open_doc() {
      this.$store.commit("Auth/OPEN_DOC", true);
    },
    formatValid(value) {
      return this.headers.find(header => header.value === "valid").formatValid(value);
    },
    formatAdditif(value) {
      return value && value.length > 0 ? "Oui" : "Non";
    },
    formatAdditifValid(value) {
      return this.headers.find(header => header.value === "extensionList.valid").formatAdditifValid(value);
    },
    hasAdditif(item) {
    return item.extensionList && item.extensionList.length > 0;
  },
    //FONCTION DE VERIFICATION LIEN AVEC DOSSIER
    listNoticeFilteredFromDocId() {
      return this.$store.getters["Auth/getListAvis"].filter(item => {
        switch (this.doc.type) {
          case 1:
            return item.noticeType.status == 2;
          case 2:
            return item.noticeType.status == 3;
          case 3:
            return item.noticeType.status == 4;
          case 4:
            return item.noticeType.status == 6;
          case 5:
            return item.noticeType.status == 5;
          case 6:
            return item.noticeType.status == 7;
          case 7:
            return item.noticeType.status == 7;
        }
      });
    },
    async UsersToSelect() {
      await this.listNoticeFilteredFromDocId();
      if (this.doc.notice) {
        this.$store.dispatch("Auth/getNotice", this.doc.notice);
      }
    },
    close_doc() {
      this.$store.commit("Auth/OPEN_DOC", false);
    },
    goto(value) {
      const { id } = value;
      this.$router.push({ name: "showDossierAno", params: { id: id } });
    },
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = { ...item };
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      confirm("Are you sure you want to delete this item?") && this.desserts.splice(index, 1);
    },
    getPPM(item) {
      console.log(item);
      this.$router.push({ name: "user", params: { ppm: item } });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    }
  }
};
</script>
<style scoped>
.vue-daterange-picker {
  width: 100%;
}

.mx-datepicker {
  width: 100%;
}

.v-card__text {
  width: 100% !important;
}
</style>